import React from 'react'
import { TrackerProps } from '../../types'
import { ActiveCasesTable } from './ActiveCasesTable'
import {
    StyledGridItem,
    StyledJabTrackerContainer,
    StyledSource,
    StyledSyringeImg,
    StyledTitleGridItem,
} from './JabTracker.styled'
import { TotalCases } from './TotalCases'
import { WAVaccinationBar } from './WAVaccinationBar'

const syringeImg = require('./assets/syringe.png')

export function PNJabTracker({
    containerRatios,
    isLoading,
    type,
    data,
}: TrackerProps) {
    console.log({ type, containerRatios })
    return (
        <StyledJabTrackerContainer
            type={type}
            isLoading={isLoading}
            containerRatios={containerRatios}
        >
            <StyledTitleGridItem type={type}>
                <div>
                    <h3>COVID 19 TRACKER</h3>
                    <p>
                        <span>active cases</span>
                        <span> Local active cases as of today</span>
                    </p>
                </div>
                <div className="StyledTitleGridItem--total-case-wrap">
                    {data && <TotalCases type={type} data={data && data} />}
                </div>
                <StyledSyringeImg src={syringeImg} alt="Covid syringe" />
            </StyledTitleGridItem>

            <StyledGridItem>
                {data && <ActiveCasesTable type={type} data={data} />}
            </StyledGridItem>

            <StyledGridItem>
                {data && (
                    <WAVaccinationBar
                        data={data}
                        isLoading={isLoading}
                        type={type}
                    />
                )}
            </StyledGridItem>

            <StyledSource>
                Source: <a href="https://covidlive.com.au">covidlive.com.au</a>
            </StyledSource>
        </StyledJabTrackerContainer>
    )
}
